<script>

import { required } from "vuelidate/lib/validators";
import Monitor from "@/services/Monitor";
import Aws from "../../../../services/Aws";

export default {
  components: {

  },
  props: {
    tenant: {
      type: String,
      default: null,
    },
    existingTenants: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      tenants: [],
      types: [],
      type: '',
      cron_execution_data: [],
      selectedTenant: "",
      csrf_token: localStorage.getItem("csrf_token"),
    };
  },
  methods: {
    onShow() {
      this.getTenants();
      this.getCronExecution();
    },
    resetProps() {
      this.submitted = false;
      this.tenants = [];
      this.selectedTenant = "";
      this.type = "";
      this.cron_execution_data = [];
    },
    refreshData() {
      this.$emit("onRefresh"); //event from parent
    },
    closeModal() {
      this.showModal = false;
    },
    getTenants() {
      Monitor.getTenants()
        .then((response) => {
          this.tenants = response.data.tenants;
        })
        .catch((error) => {});
    },
     getCronExecution() {
      Monitor.getCronExecution()
        .then((response) => {
          this.cron_execution_data = response.data.data || [];
          const distinctTypes = Array.from(new Set(this.cron_execution_data.map(item => item.type).filter(Boolean)));
          this.types = distinctTypes;
          if(!this.type && this.types.length > 0){
            this.type = this.types[0];
          }
        })
        .catch((error) => {
          this.cron_execution_data = [];
          this.types = [];
        });
    },

     createCronExecutionTeam() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.tryingToSubmit = true;
      if (this.$v) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.tryingToSubmit = false;
          return;
        }
      }
      let formData = new FormData();
      formData.append("tenant", this.selectedTenant);
      formData.append("type", this.type);
      Monitor.addCronExecutionTeam(formData)
        .then((response) => {
          const res = response.data ? response.data : false;
          const error = response.data.error ? response.data.error : "";
          if (res) {
            this.successmsg("Cron Execution Created!");
            this.refreshData();
            this.closeModal();
          } else {
            this.failedmsg("Failed to create cron execution!");
          }
        })
        .catch((error) => {
          const resData = error.response.data.error
            ? error.response.data.error
            : "Failed";
          const errorMsg = Array.isArray(resData) ? resData[0] : resData;
          this.failedmsg(errorMsg);
        })
        .finally(() => {
          this.tryingToSubmit = false;
        });
    },
  }

};
</script>

<template>
  <b-modal
    id="add_cron_execution_tenant"
    size="md"
    v-model="showModal"
    @shown="onShow"
    @hidden="resetProps"
    title="Add New Cron Execution"
    title-class="font-18"
  >
    <form @submit.prevent="createCronExecutionTeam()">
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label class="control-label form-label">Tenant</label>
            <select
              v-model="selectedTenant"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                {{ tenant }}
              </option>
            </select>
          </div>

         <div class="mb-3">
            <label class="control-label form-label">Type</label>
            <select
              v-model="type"
              class="form-control form-select"
              name="option"
              type="select"
            >
              <option v-for="type in types" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>

        </div>
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button
        variant="primary"
        @click="createCronExecutionTeam"
        :disabled="tryingToSubmit"
      >
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
